import isAuth from './isAuth';

export default (to) => { return true && isAuth(); };
